module.exports = __webpack_public_path__ + "img/批量变更.1229c5de.svg";